import moment from "moment";

const calendarMenuItems = [
    {
        enabled: true,
        key: "calendar",
        path: "/calendar/d/" + moment().format().split("T")[0],
        label: this?.$t("message.calendar") || "Takvim",
        icon: {
            type: "material-icons",
            name: "calendar_today",
        },
    },
    {
        enabled: true,
        key: "reservationBuilder",
        path: "/reservation/landing-page",
        label: this?.$t("calendar.reservationBuilder") || "Rezervasyon Websitesi",
        icon: {
            type: "material-icons",
            name: "web",
        },
    },
    {
        enabled: true,
        key: "events",
        path: "/calendar/events",

        label: this?.$t("calendar.events") || "Etkinlikler",
        icon: {
            type: "material-icons",
            name: "event",
        },
    },
    {
        enabled: true,
        key: "reservations",
        path: "/calendar/reservations",
        label: this?.$t("calendar.reservations") || "Rezervasyonlar",
        icon: {
            type: "material-icons",
            name: "book_online",
        },
    },
    {
        enabled: true,
        key: "reservationPrograms",
        path: "/reservation/programs",
        label: this?.$t("calendar.reservationPrograms") || "Rezervasyon Programları",
        icon: {
            type: "material-icons",
            name: "event_note",
        },
    },
    {
        enabled: true,
        key: "automations",
        path: "/reservation/automations",
        label: this?.$t("calendar.automations") || "Otomasyonlar",
        icon: {
            type: "component",
            name: "atomic-power",
            class: "myIcon",
            style: { fill: "var(--color-icon-primary-default)" },
        },
    },
];
export default calendarMenuItems;
